import React from 'react';
import FurnitureCategory from 'components/Tvendo/BusinessPartner/DataMaster/FurnitureCategory/List.js';

export default function () {
  return <FurnitureCategory />;
}
